import React, { useEffect, useState } from 'react';
//import axios from '../../node_modules/axios/index';
import './Thanks.css';
//import { CentralCall } from '../CommonMethods/CentralCall';
import { apiURL } from '../index';
import thankYou from '../Images/PaymentSuccess/success.svg';
import alert from '../Images/PaymentSuccess/alert.svg';
import faile from '../Images/PaymentSuccess/failed.svg';
import InsurerLogo from '../Images/reliance.png';
import pdf from '../Images/PaymentSuccess/pdf-download.svg';
import axios from "axios";
import { baseUrl } from "../index";

const PaymentSuccessOrFailDumy = (props) => {
    const [PdfBytes, setPDFBytes] = useState("");
    let InsurerLogo = "";
    let CompanyName = "";
    const url = new URLSearchParams(window.location.search);
    const TransactionStatus = url.get("TransactionStatus") == "Success" ? "True" : "False";    
    const Premium = url.get("Premium");
    const TransectionID = url.get("TransectionNo");
    const PolicyNo = url.get("policyNo");
    const Path = url.get("Path"); 
    const EnquiryNo = url.get("EnquiryNo");
    const InsurerID = url.get("InsurerID");


    //const LeadEnq = window.localStorage.getItem("LeadEnq");
    switch (InsurerID) {
        case "112":
            InsurerLogo = window.location.origin + "/insurer logo/realince_logo.png";
            CompanyName = "Reliance"
            break;
    }


    function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    function saveByteArray(reportName, byte) {
        var blob = new Blob([byte], { type: "application/pdf" });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    };
    const DownloadPolicyPdf = async () => {

        //window.open(window.location.origin + "/TravelPolicy/" + PolicyNo + ".pdf", '_blank');
        //console.log("PDFPATH", Path);
        //window.location.href = "";

        let model = {
            URL: `/pg/DownloadFile?PolicyNo=${PolicyNo}`,
            IsGet: true
        }
        try {
            const response = await axios.post(`${baseUrl}/services/call`, model);
            saveByteArray(`${PolicyNo}.pdf`, base64ToArrayBuffer(response.data))
        } catch (error) {
            return Promise.resolve([]);
        }
    }


    //const PolicyPdf = () => {
    //    const Model = {
    //        URL: `${apiURL}api/HomeInsurance/GetPolicyPdf`,
    //        Req: {
    //            EnquiryNo
    //        },
    //        IsPost:true
    //    }
    //    CentralCall(Model).then(res => {
    //        if (res.status === 200) {
    //            saveByteArray(`${PolicyNo}.pdf`, base64ToArrayBuffer(res.data));
    //        }
    //    })
    //}
    return (
        <section className="PayThanksPage" style={{ backgroundColor: "#dee2e6", height: '650px', width: '700px', textAlign: 'center', display: 'block', marginLeft: 'auto', marginRight:'auto' }}>
            <div className="container">
                <div className="PayThanksPageBox">
                    <div className="PayThanksPageBox1">
                        {props.IsLoader ? "Loading.." : TransactionStatus == "True" ?
                            <React.Fragment>
                                <img src={thankYou} />
                                <h1 className="PayThanksTitle" style={{ textAlign: 'center' }}>
                                    Your payment was <span>successful.</span>
                                </h1>
                            </React.Fragment> : TransactionStatus == "False" ?
                                <React.Fragment>
                                    <img src={faile} />
                                    <h1 className="PayThanksTitle" >
                                        Ooops! Payment <span className="failed">failed.</span>
                                    </h1>

                                </React.Fragment> :
                                <React.Fragment>
                                    <img src={alert} />
                                    <h1 className="PayThanksTitle">
                                        It seems there is an issue.

                                    </h1>
                                    <small>Wait for at least 24 hours, you will receive an update on your registered email id.</small>
                                </React.Fragment>
                        }
                    </div>
                    <div className="PayThanksPageBox2" style={{ fontSize: '16px', color: '#3d3d3d' }}>
                        {(TransactionStatus === "True" || TransactionStatus === "False") && < div className="innerBox">
                            {TransactionStatus !== "False" ? <h3 style={{ textAlign: 'center' }}>Your online policy Purchase ID: <span>{props.IsLoader ? "Loading.." : EnquiryNo}</span></h3> : <h3>Your online policy Transaction ID: <span>{props.IsLoader ? "Loading.." : TransectionID}</span></h3>}
                            {TransactionStatus !== "False" && <h3 style={{ textAlign: 'center' }}>Your online policy No: <span>{props.IsLoader ? "Loading.." : PolicyNo}</span></h3>}
                            {TransactionStatus !== "False" && <p>{props.IsLoader ? "Loading.." : "Your policy document:"}  <a onClick={() => DownloadPolicyPdf()}><img src={pdf} /></a></p>}
                            {/*{TransactionStatus !== "False" && <p style={{ textAlign: 'center' }}>{props.IsLoader ? "Loading.." : "GOTO Downlode Policy  PDF :"} */}  {/*<a onClick={PolicyPdf} ><img src={require("../Images/PaymentSuccess/pdf-download.svg")} /></a></p>}*/}
                           
                        </div>}

                        <div className="innerBoxOf">
                            <div className="innerBox">
                                {props.IsLoader ? "Loading.." : <img src={InsurerLogo} alt="Payment Logo" />}
                            </div>
                            <div className="innerBox">
                                <h4 style={{ textAlign: 'center' }}>Total Premium</h4>
                                <h5 style={{ textAlign: 'center' }}>{props.IsLoader ? "Loading.." : Premium ? ("₹ " + Premium) : "Not Available"}</h5>
                            </div>
                        </div>
                        {/*{PaymentStatus === "True" ? <p style={{ textAlign: 'center' }}>If you are not able to download policy documents from above link. You will get policy documents on your registerd Email ID. </p> : <p>Dear Customer, your payment transaction has failed. Please try again. In case the amount has been deducted from your account, it will be refunded within 2-3 working days.</p>}*/}

                    </div>
                </div>
               
            </div>
        </section>

    )

        
}

export default PaymentSuccessOrFailDumy